"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewEntityContextMap = exports.contextMapToArray = exports.getNewEntityContext = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const TypeHelpers_1 = require("../../TypeHelpers");
const ModelTypes_1 = require("../../../types/ModelTypes");
const classDependentTypes_1 = require("../../../classDependentTypes");
const geo_1 = require("../../geo");
const turf_1 = require("@turf/turf");
/** creates a mock customer A, group, Customer B group Device structure with n devices.  returns device, thing, group and customers as list  */
/** creates a mock customer A, group, Customer B group Device structure with n devices.  returns device, thing, group and customers as list  */
const getNewEntityContext = (params) => {
    const { targetArea } = params;
    const contextMap = (0, exports.getNewEntityContextMap)(params);
    const context = (0, exports.contextMapToArray)(contextMap);
    if (targetArea) {
        context.push(targetArea);
    }
    return context;
};
exports.getNewEntityContext = getNewEntityContext;
const contextMapToArray = (contextMap) => {
    const { areaPlaceEdges, customerCustomerGroupEdge, customerDeviceAllocationEdges, customerDeviceGroupEdge, customerDeviceInventoryEdges, customerEntityGroupEdge, customerGroupDeviceGroupEdge, customerPropertyEdge, deviceEntityEdges, deviceGroup, entityGroup, entityGroupEdges, entityPlaceEdges, entityPropertyEdges, groupDeviceEdges, primaryCustomer, primaryGroup, subCustomer, targetArea, zombieDevices, zombieEntities, zombiePlaces, zombieProperty, } = contextMap;
    const context = [
        ...areaPlaceEdges,
        ...customerDeviceAllocationEdges,
        ...customerDeviceInventoryEdges,
        ...deviceEntityEdges,
        ...entityGroupEdges,
        ...entityPlaceEdges,
        ...entityPropertyEdges,
        ...groupDeviceEdges,
        ...zombieDevices,
        ...zombieEntities,
        ...zombiePlaces,
        customerCustomerGroupEdge,
        customerDeviceGroupEdge,
        customerEntityGroupEdge,
        customerGroupDeviceGroupEdge,
        customerPropertyEdge,
        deviceGroup,
        entityGroup,
        primaryCustomer,
        primaryGroup,
        subCustomer,
        zombieProperty,
    ];
    return context;
};
exports.contextMapToArray = contextMapToArray;
/** creates a mock customer A, group, Customer B group Device structure with n devices.  returns device, thing, group and customers as list  */
const getNewEntityContextMap = ({ numberOfDevices = 1, networkKey = iotv_v3_types_1.Networks.Interceptor, devEuiLength = 16, deviceEUIStart = 0x00000123, _permittedAWOL, deviceType, deviceEnabledTypeId, appID = 'mock', apexCustomer, apexCustomerGroup, targetCustomer, targetProperty, targetArea, }) => {
    const providedAreaBounds = (0, iotv_v3_types_1.isIGeofence)(targetArea) ? targetArea.points : undefined;
    let targetCells = undefined;
    if ((0, iotv_v3_types_1.isAreaWithGrids)(targetArea)) {
        const { metadata } = targetArea;
        const { grids } = metadata;
        const gridsArr = Object.values(grids);
        const targetGrid = gridsArr.at(0);
        if (targetGrid) {
            const { cells } = targetGrid;
            targetCells = cells;
        }
    }
    if (targetCells) {
        console.log(`mutating number of devices to match discovered cells in grid ${targetCells.length}`);
        numberOfDevices = targetCells.length;
    }
    const bounds = providedAreaBounds ?? (0, geo_1.extendPointToPoints)({ lat: 50.813676, lng: -2.4747 }, 1000);
    const zombieDevices = (0, TypeHelpers_1.getPredictableDeviceZombies)({
        deviceType,
        appID,
        networkKey,
        numberOfDevices,
        devEuiLength,
        deviceEUIStart,
        _permittedAWOL,
    });
    const zombieEntities = (0, TypeHelpers_1.getPredictableZombies)(deviceEnabledTypeId, numberOfDevices);
    const zombieProperty = targetProperty ? targetProperty : (0, iotv_v3_types_1.getPredictableZombie)('Property', 1, { name: 'TestPrimaryCustomerGroup' });
    if (!zombieProperty.location) {
        zombieProperty.location = (0, geo_1.getRandomPointInPoints)(bounds);
    }
    const zombiePlaces = (0, TypeHelpers_1.getPredictableZombies)('Place', numberOfDevices);
    zombiePlaces.forEach((z, i) => {
        const correspondingCell = targetCells?.[i];
        if ((0, iotv_v3_types_1.isIGeofence)(correspondingCell)) {
            const pArray = correspondingCell.points
                .filter(({ lat, lng }) => (0, iotv_v3_types_1.isNonNaNNumber)(lat) && (0, iotv_v3_types_1.isNonNaNNumber)(lng))
                .map(({ lat, lng }) => [lng, lat]);
            const xCenter = (0, turf_1.center)((0, turf_1.points)(pArray)).geometry.coordinates;
            z.location = (0, geo_1.convertTurfPointsToGLatLng)(xCenter);
        }
        else {
            z.location = (0, geo_1.getRandomPointInPoints)(bounds);
        }
    });
    const entityPlaceEdges = zombieEntities
        .map((e, i) => {
        const place = zombiePlaces.at(i);
        if (place) {
            return (0, TypeHelpers_1.getZombieEdge)(e, place, (0, classDependentTypes_1.getEntityToPlaceEdgeTypeId)(e.type)); //cant rely on datamodel constructed edgeTypeIds here
        }
        else
            return null;
    })
        .filter(iotv_v3_types_1.isValidBusinessObject);
    const primaryCustomer = apexCustomer ?? (0, TypeHelpers_1.getZombieInstanceFromPrimaryKey)('Customer:A', { name: 'TestPrimaryCustomer', accountType: ModelTypes_1.CustomerAccountType.X });
    const primaryGroup = apexCustomerGroup ?? (0, TypeHelpers_1.getZombieInstanceFromPrimaryKey)('Group:A', { name: 'TestPrimaryCustomerGroup', supportedType: 'Customer' });
    const subCustomer = targetCustomer ?? (0, TypeHelpers_1.getZombieInstanceFromPrimaryKey)('Customer:B', { name: 'TestCustomer', accountType: ModelTypes_1.CustomerAccountType.Y });
    const supportedTypeDevice = 'Device';
    const deviceGroup = (0, TypeHelpers_1.getZombieInstanceFromPrimaryKey)('Group:B', { name: 'TestCustomerDeviceGroup', supportedType: supportedTypeDevice });
    const supportedTypeEntity = deviceEnabledTypeId;
    const entityGroup = (0, TypeHelpers_1.getZombieInstanceFromPrimaryKey)('Group:C', { name: 'TestCustomerEntityGroup', supportedType: supportedTypeEntity });
    const deviceEntityEdges = zombieEntities.map((entity, i) => {
        return (0, TypeHelpers_1.getZombieEdge)(entity, zombieDevices[i], (0, classDependentTypes_1.getChildEdgeTypeId)(entity.type, zombieDevices[i].type));
    });
    const entityPropertyEdges = zombieEntities.map((entity, i) => {
        return (0, TypeHelpers_1.getZombieEdge)(zombieProperty, entity, `property_has_${deviceEnabledTypeId}`);
    });
    const entityGroupEdges = zombieEntities.map((entity, i) => {
        return (0, TypeHelpers_1.getZombieEdge)(entityGroup, entity, `group_has_${deviceEnabledTypeId}`);
    });
    const areaPlaceEdges = targetArea ? zombiePlaces.map((place) => (0, TypeHelpers_1.getZombieEdge)(targetArea, place, classDependentTypes_1.edgeTypeMatrix.Area.Place.area_has_place.edgeTypeId)) : [];
    const customerCustomerGroupEdge = (0, TypeHelpers_1.getZombieEdge)(primaryCustomer, primaryGroup, classDependentTypes_1.edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId);
    const customerGroupDeviceGroupEdge = (0, TypeHelpers_1.getZombieEdge)(primaryGroup, subCustomer, classDependentTypes_1.edgeTypeMatrix.Group.Customer.group_has_customer.edgeTypeId);
    const customerDeviceGroupEdge = (0, TypeHelpers_1.getZombieEdge)(subCustomer, deviceGroup, classDependentTypes_1.edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId);
    const customerPropertyEdge = (0, TypeHelpers_1.getZombieEdge)(subCustomer, zombieProperty, classDependentTypes_1.edgeTypeMatrix.Customer.Property.customerHasProperty.edgeTypeId);
    const customerEntityGroupEdge = (0, TypeHelpers_1.getZombieEdge)(subCustomer, entityGroup, classDependentTypes_1.edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId);
    const customerDeviceInventoryEdges = zombieDevices.map((device) => (0, TypeHelpers_1.getZombieEdge)(primaryCustomer, device, classDependentTypes_1.edgeTypeMatrix.Customer.Device.customer_device_inventory_includes.edgeTypeId));
    const customerDeviceAllocationEdges = zombieDevices.map((device) => (0, TypeHelpers_1.getZombieEdge)(subCustomer, device, classDependentTypes_1.edgeTypeMatrix.Customer.Device.customer_has_been_allocated_device.edgeTypeId));
    const groupDeviceEdges = zombieDevices.map((device) => (0, TypeHelpers_1.getZombieEdge)(deviceGroup, device, classDependentTypes_1.edgeTypeMatrix.Group.Device.group_has_device.edgeTypeId));
    const contextMap = {
        areaPlaceEdges,
        customerCustomerGroupEdge,
        customerDeviceAllocationEdges,
        customerDeviceGroupEdge,
        customerDeviceInventoryEdges,
        customerEntityGroupEdge,
        customerGroupDeviceGroupEdge,
        customerPropertyEdge,
        deviceEntityEdges,
        deviceGroup,
        entityGroup,
        entityGroupEdges,
        entityPlaceEdges,
        entityPropertyEdges,
        groupDeviceEdges,
        primaryCustomer,
        primaryGroup,
        subCustomer,
        zombieDevices,
        zombieEntities,
        zombiePlaces,
        zombieProperty,
    };
    if (targetArea) {
        console.log('adding area', targetArea);
        contextMap.targetArea = targetArea;
    }
    return contextMap;
};
exports.getNewEntityContextMap = getNewEntityContextMap;
